import { ChangeEvent, useEffect } from 'react';
import { Trans, WithTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import Checkbox from '../../../../common/checkbox/checkbox';
import { AGB_ANCHOR_NAMES, AGB_EXTERNAL_LINKS, getAGBAnchor } from '../../../../constants/agb';
import Routes from '../../../../constants/routes';
import translation, { world } from '../../../../languages';
import { AVAILABLE_WORLDS } from '../../../../languages/constants';
import isMobileAppWebview from '../../../../utils/is-mobile-app-webview';
import { changeFormData } from '../../reducers';
import qualityEvents from '../../../../services/quality-events/quality-events';
import './agb-info.scss';

type AgbInfoProps = WithTranslation & {};

const AgbInfo = ({ t }: AgbInfoProps) => {
    const mobileAppUrlParam = isMobileAppWebview() ? '?mobileApp=true' : '';
    const user = useSelector((state: RootState) => state.main.user);
    const dispatch = useDispatch();

    useEffect(() => {
        if (user?.id) {
            dispatch(changeFormData({ acceptAgb: true }));
        }
    }, [user.loaded]);

    const onAgbChanged = (e: ChangeEvent<HTMLInputElement>) => {
        dispatch(changeFormData({ acceptAgb: e.currentTarget.checked }));

        qualityEvents.checkoutPage.agbCheckboxChange(e.currentTarget.checked);
    };

    const title = (
        <Trans i18nKey='payment.acceptAGB' t={t}>
            Mit deiner Bestellung erklärst du dich mit unseren
            <Link className='navlink-color' target='_blank' to={`${Routes.AGB.path}${mobileAppUrlParam}${getAGBAnchor(AGB_ANCHOR_NAMES.termsAndConditions)}`}>Nutzungsbedingungen</Link>
            und
            <Link className='navlink-color' target='_blank' to={AGB_EXTERNAL_LINKS[world] ? AGB_EXTERNAL_LINKS[world].withdrawalAgreement : AGB_EXTERNAL_LINKS[AVAILABLE_WORLDS.DE].withdrawalAgreement}>Widerrufsbelehrung</Link>
            einverstanden. Bitte beachten Sie auch unsere
            <Link className='navlink-color' target='_blank' to={`${Routes.AGB.path}${mobileAppUrlParam}${getAGBAnchor(AGB_ANCHOR_NAMES.dataProtection)}`}>Datenschutzbestimmungen</Link>.
        </Trans>
    );

    return (
        <div className='payment-container agb'>
            {user?.id && (<div>
                {title}
                <input
                    id='hiddenAgbCheckbox'
                    type='checkbox'
                    checked
                    readOnly
                    name='acceptAgb'
                    style={{ visibility: 'hidden' }}
                />
            </div>)}
            {!user?.id && (<div>
                <Checkbox
                    className='lg agb-info'
                    id='invoice-accept-the-agreement'
                    name='acceptAgb'
                    tabIndex={0}
                    title={title as unknown as string & Element}
                    type='checkbox'
                    onChange={onAgbChanged}
                    checkedBgColor='dark'
                />
            </div>)}
        </div>
    );
};

const translate = translation('payment');

export default translate(AgbInfo);
